import { createBrowserRouter } from 'react-router';
import { LoginPage } from '../features/auth/LoginPage';
import { RegisterPage } from '../features/auth/RegisterPage';
import { RequireAuth } from '../features/auth/RequireAuth';
import { ParentsPage } from '../features/parents/ParentsPage';
import { ProfilePage } from '../features/profile/ProfilePage';
import { PlayPage } from '../features/rooms/PlayPage';
import { StartPage } from '../features/rooms/StartPage';
import { NotFoundPage } from './NotFoundPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/parents', element: <ParentsPage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/', element: <StartPage /> },
      { path: '/play/:gameId', element: <PlayPage /> },
      { path: '/profile', element: <ProfilePage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
